<template>
  <div>
    <va-layout>
      <template #header>
        <header>
          <div class="mt-6 mx-4">
            <div class="d-flex align-center">
              <router-link to="/" class="d-flex align-center text-decoration-none">
                <v-img :src="appLogo" alt="logo" max-height="20" max-width="110" class="me-3"></v-img>
              </router-link>
            </div>
          </div>
        </header>
      </template>
      <template #footer>
        <cookie-bar v-if="$can('view', 'cookie bar')"></cookie-bar>
        <footer width="auto" class="py-12 footer-text">
          © {{ new Date().getFullYear() }} <a :href="'https://' + appDomain">{{ appDomain }}</a
          >.
          <a class="text--subtitle" :href="'https://' + appDomain + '/terms-of-use'">{{ $t("generic.terms") }}</a>
          {{ $t("generic.and") }}
          <a class="text--subtitle" :href="'https://' + appDomain + '/privacy-policy'">
            {{ $t("generic.privacy_policy") }}
          </a>
        </footer>
      </template>
    </va-layout>
  </div>
</template>

<script>
  import themeConfig from "@themeConfig";
  import CookieBar from "@/components/custom/CookieBar.vue";

  export default {
    components: {
      CookieBar,
    },
    data() {
      return {
        appDomain: themeConfig.app.domain,
        appLogo: themeConfig.app.logo,
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .footer-text {
    color: get-color("subtitle");
    font-size: 14px;
    line-height: 24px;
    text-align: center;

    a {
      color: get-color("subtitle") !important;
    }
  }
</style>
